//This file is to make the jqgrid use our dynamic GUI translations
//in case we need to override the jqgrid defaults
//
// `translate` is defined by TypeScript/pages/translations.ts, which is loaded as an ES module
// (`type="module"`). Module scripts are always deferred (run after the document has been parsed),
// regardless of where they appear relative to this classic script in the markup — so `translate`
// is NOT yet defined when this file executes inline. Deferring to DOMContentLoaded guarantees the
// translations module has already run (module scripts must finish before that event fires).
document.addEventListener("DOMContentLoaded", function () {
	if (typeof $.jgrid !== "undefined" && $.jgrid.defaults) {
		$.extend($.jgrid.defaults, { emptyrecords: translate("GUI00692", "No records to view") });
	}

	// jqGrid's default iconSet ("Iconic") renders pager/nav/sort icons using Open Iconic
	// (classes like "oi oi-caret-right"), but this project never included the Open Iconic
	// font/CSS. That leaves the icons blank (no glyph) wherever a grid uses jqGrid's native
	// UI (e.g. DrumLog, WebViewers) instead of a custom pagination component.
	// Font Awesome 4 *is* bundled and loaded on every page that uses jqGrid, so we remap the
	// "Iconic" icon classes to their Font Awesome 4 equivalents here, once, for all grids.
	if (typeof $.jgrid !== "undefined" && $.jgrid.iconSet && $.jgrid.iconSet.Iconic) {
		$.extend(true, $.jgrid.iconSet.Iconic, {
			common: {
				icon_base: "fa"
			},
			base: {
				icon_first: "fa-step-backward",
				icon_prev: "fa-backward",
				icon_next: "fa-forward",
				icon_end: "fa-step-forward",
				icon_asc: "fa-sort-asc",
				icon_desc: "fa-sort-desc",
				icon_caption_open: "fa-chevron-up",
				icon_caption_close: "fa-chevron-down"
			},
			modal: {
				icon_close: "fa-times-circle",
				icon_resizable: "fa-plus"
			},
			inlinedit: {
				icon_edit_nav: "fa-pencil",
				icon_add_nav: "fa-plus",
				icon_save_nav: "fa-check",
				icon_cancel_nav: "fa-undo"
			},
			formedit: {
				icon_prev: "fa-chevron-left",
				icon_next: "fa-chevron-right",
				icon_save: "fa-check",
				icon_close: "fa-ban",
				icon_del: "fa-trash",
				icon_cancel: "fa-ban"
			},
			navigator: {
				icon_edit_nav: "fa-pencil",
				icon_add_nav: "fa-plus",
				icon_del_nav: "fa-trash",
				icon_search_nav: "fa-search",
				icon_refresh_nav: "fa-refresh",
				icon_view_nav: "fa-eye",
				icon_newbutton_nav: "fa-book"
			},
			grouping: {
				icon_plus: "fa-chevron-right",
				icon_minus: "fa-chevron-down"
			},
			filter: {
				icon_search: "fa-search",
				icon_reset: "fa-refresh",
				icon_query: "fa-comment-o"
			},
			subgrid: {
				icon_plus: "fa-chevron-right",
				icon_minus: "fa-chevron-down",
				icon_open: "fa-indent"
			},
			treegrid: {
				icon_plus: "fa-plus",
				icon_minus: "fa-minus",
				icon_leaf: "fa-circle"
			},
			fmatter: {
				icon_edit: "fa-pencil",
				icon_add: "fa-plus",
				icon_save: "fa-check",
				icon_cancel: "fa-undo",
				icon_del: "fa-trash"
			},
			colmenu: {
				icon_menu: "fa-list",
				icon_sort_asc: "fa-sort-asc",
				icon_sort_desc: "fa-sort-desc",
				icon_columns: "fa-columns",
				icon_filter: "fa-search",
				icon_group: "fa-list-alt",
				icon_freeze: "fa-table",
				icon_move: "fa-arrows",
				icon_new_item: "fa-external-link",
				icon_toolbar_menu: "fa-bars",
				icon_group_op: "",
				icon_oper_op: "",
				icon_reset: "fa-refresh",
				icon_close: "fa-ban"
			},
			clipboard: {
				icon_copy: "fa-copy",
				icon_paste: "fa-clipboard",
				icon_paste_add: "fa-download",
				icon_repeat_row: "fa-arrow-down",
				icon_repeat_col: "fa-arrow-right",
				icon_undo: "fa-undo",
				icon_cancel: "fa-sign-out"
			}
		});
	}
});
